// extracted by mini-css-extract-plugin
export default {"BreakpointToSmall":"(max-width: 374px)","container":"Gf28f98"};